class MiniCart extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector("sticky-header");
    this.drawer = document.querySelector("cart-drawer");
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        document.getElementById("mini-cart").innerHTML =
          this.getSectionInnerHTML(html, ".shopify-section");

        document.dispatchEvent(new CustomEvent("cartdrawer:opened"));
      })
      .catch((e) => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector("details");
    if (detailsElement.hasAttribute("open")) {
      return;
    }

    const summaryElement = this.drawer.querySelector("summary");
    summaryElement.click();
  }

  async renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    const requestCart = await fetch(`${window.routes.cart_url}`, {
      ...fetchConfig(),
    });
    const cart = await requestCart.json();

    const cartItems = cart.items;
    const cartTotal = cart.total_price;
    const items = [...document.querySelectorAll(".cpb-icons .cbp-item")];
    const variants = {};

    for (let item of items) {
      const price = item.dataset.itemPrice;
      const variantId = item.dataset.variantId;

      if (variantId == "") continue;

      if (cartTotal >= parseInt(price)) {
        variants[`${variantId}`] = 1;
      }
    }

    if (Object.keys(variants).length !== 0) {
      const sections = this.getSectionsToRender().map(
        (section) => section.section
      );

      const request = await fetch(`${window.routes.cart_update_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({
          updates: variants,
          sections: sections,
          sections_url: window.location.pathname,
        }),
      });
      const state = await request.json();

      this.productId = state.id;
      this.getSectionsToRender().forEach((section) => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(
            state.sections[section.id],
            section.selector
          );
      });
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "mini-cart",
        section: "mini-cart",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

customElements.define("mini-cart", MiniCart);
